// extracted by mini-css-extract-plugin
export default {"uploadDocument":"styles_uploadDocument__6jv5R","uploadIcon":"styles_uploadIcon__a1xjw"};